export default class ComponentEvent {

    constructor(type, props = {}) {
        this.type = type;
        this.target = (props.hasOwnProperty('target') ? props.target : null);
    }

}